<header>
    <div class="container">
        <div class="logos">
            <div id="client-logo" class="logo"></div>
        </div>
        <div class="logo-agos">
            <div id="agoslogo" class="logo"></div>
            <p>Firma digitale</p>
        </div>
    </div>
</header>
